import { navigate } from '@reach/router';

const goHash = hash => {
  navigate(hash);
};

export default goHash;
